export var FIND_BOOKING_SOURCE_PMS = {
  OPERA: 'Opera',
  BART: 'Bart'
};
export var FIND_BOOKING_COOKIE_NAME_KEY = 'findBookingCookieName';